import { useState, type FC } from "react";
import { Button } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useTranslation, useUser } from "@/shared/hooks";
import { openAssistant, useAssistantAvailable } from "@/features/assistant";
import { ProductFeedbackDialog } from "./ProductFeedbackDialog";

/**
 * Гостю клик открывает диалог входа тем же способом, что и у избранного и
 * лайков (openSignIn из UserContext, порт референсного клика по
 * `.js-sign-in`), а не показывает форму, которую всё равно нельзя отправить.
 *
 * Если на арене включён помощник, кнопка вместо формы открывает его панель:
 * гостю она сама покажет вход, а URL страницы продукта помощник уже получает
 * контекстом с каждым сообщением, отдельно передавать ничего не нужно.
 * Старый диалог формы остаётся только там, где помощник выключен.
 */
export const ProductFeedbackButton: FC<{ productId: string }> = ({
  productId,
}) => {
  const { t } = useTranslation();
  const { user, openSignIn } = useUser();
  const { available: assistantAvailable } = useAssistantAvailable();
  const [open, setOpen] = useState(false);

  const onClick = () => {
    if (assistantAvailable) {
      openAssistant();
      return;
    }
    if (!user) return openSignIn();
    setOpen(true);
  };

  return (
    <>
      <Button
        variant="soft"
        size="medium"
        startIcon={<MailOutlineIcon />}
        onClick={onClick}
      >
        {t("productFeedback.button")}
      </Button>

      {!assistantAvailable && (
        <ProductFeedbackDialog
          productId={productId}
          open={open}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};
